import { StyleSheet } from 'react-native';
import { icon_img_width, icon_img_height } from '../../styles/vars/size';
import { useTheme } from '../../hooks/useTheme';
import { useStyleVars } from '../../hooks/useStyleVars';
import icons from './icons';
export function useStyle({ name = '', customStyle = {}, scalable, }) {
    var _a;
    const { mode } = useTheme();
    let kidColor;
    if (name) {
        kidColor = ((_a = icons[name]) === null || _a === void 0 ? void 0 : _a[mode]) || undefined;
    }
    const { iconColor, iconSize, iconWidth, iconHeight, iconOpacity } = customStyle;
    const customVars = {
        kid_icon_color: iconColor || kidColor,
        kid_icon_size_width: iconWidth || iconSize,
        kid_icon_size_height: iconHeight || iconSize,
        kid_icon_opacity: iconOpacity,
    };
    const defaultVars = {
        // 颜色变量
        kid_icon_color: undefined,
        // 尺寸变量
        kid_icon_size_width: icon_img_width,
        kid_icon_size_height: icon_img_height,
        kid_icon_opacity: iconOpacity !== 0 ? 1 : 0,
    };
    const vars = useStyleVars({
        defaultVars,
        customVars,
        scalable,
    });
    return {
        vars,
        style: StyleSheet.create({
            icon: {
                tintColor: vars.kid_icon_color,
                width: vars.kid_icon_size_width,
                height: vars.kid_icon_size_height,
                opacity: vars.kid_icon_opacity,
            },
        }),
    };
}
